var sliderTexts = {
  'sv-SE': {
    from: 'Från',
    to: 'till'
  },
  'nb-NO': {
    from: 'Fra',
    to: 'til'
  },
  'da-DK': {
    from: 'Fra',
    to: 'til'
  },
  'fi-FI': {
    from: '',
    to: '-'
  },
  en: {
    from: 'From',
    to: 'to'
  }
};
var texts = sliderTexts;

export { texts as default };
//# sourceMappingURL=Slider.texts.js.map
